import {Loader} from '@googlemaps/js-api-loader';

export const gmLoader = new Loader({
  apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
  version: 'weekly',
  libraries: ["core", "places", "marker", "geometry"],
});